export const TrackingType = {
  Order: 'Order Tracking',
  Document: 'Document Tracking'
}
